import getObjectKey from 'lib/object/getObjectKey'

interface PropertyRatesKeyParams {
  propertyId: string | undefined;
  checkIn: string | undefined;
  checkOut: string | undefined;
  occupancies: Array<App.Occupants>;
  dynamicAvailability: boolean;
  utmContent: string | undefined;
  roomTypeId: string | undefined;
  roomRateId: string | undefined;
}

function buildPropertyRatesKey({
  propertyId,
  checkIn,
  checkOut,
  occupancies,
  dynamicAvailability,
  utmContent = '',
  roomTypeId = '',
  roomRateId = '',
}: PropertyRatesKeyParams): string {
  if (!(propertyId && checkIn && checkOut && occupancies.length)) {
    return ''
  }
  return getObjectKey({
    propertyId,
    checkIn,
    checkOut,
    rooms: occupancies,
    dynamicAvailability,
    utmContent,
    roomTypeId,
    roomRateId,
  })
}

export default buildPropertyRatesKey
